export default __webpack_public_path__ + "static/media/nextnovate-logo-2023-default.ba28543e.svg";